import {
  state,
  style,
  animate,
  animateChild,
  query,
  transition,
  trigger,
  keyframes,
} from '@angular/animations';

export const verticalCollapseAnimation = trigger('verticalCollapse', [
  state(
    '*',
    style({
      height: '*',
    }),
  ),
  state(
    'void',
    style({
      height: '0',
    }),
  ),
  transition('* => void', animate('.3s .3s ease')),
]);

export const triggerChildAnimation = trigger('triggerChildAnimation', [
  transition(':enter, :leave', [animate('0s'), query('*', [animateChild()])]),
]);

export const verticalExpand = trigger('verticalExpand', [
  transition(':enter', [
    animate(
      '.3s',
      keyframes([
        style({ height: 0, opacity: 0, overflow: 'hidden', offset: 0 }),
        style({ height: '*', opacity: 1, offset: 1 }),
      ]),
    ),
  ]),
]);

export const toastIcons: Readonly<{ [key: string]: string }> = {
  success: 'checkmark-circle-2-outline',
  warning: 'alert_circle_outlined',
  error: 'close_circle_outlined',
  info: 'info-2-outline',
  danger: 'close_circle_outlined', //Deprecated
};

export const defaultTitles: Readonly<{ [key: string]: string }> = {
  success: 'Success',
  error: 'Error',
  info: 'Information',
  warning: 'Warning',
  danger: 'Error', //Deprecated
};
